module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radius-slider",
    class: _vm.$style.root,
    on: {
      "changeValue": _vm.changeValue
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-wrap"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.format.radius', {
    unit: _vm.unit,
    radius: _vm.from
  })))]), _c('div', {
    staticClass: "flex-5"
  }, [_c('vue-slider', {
    ref: "vueslider",
    attrs: {
      "min": 0,
      "max": _vm.stepsCount,
      "value": _vm.selectedIndex,
      "lazy": true,
      "piecewise": true,
      "formatter": _vm.formatLabel,
      "tooltip-dir": "right",
      "height": 2,
      "dot-size": 34
    },
    on: {
      "callback": _vm.onCallback
    }
  })], 1), _c('div', {
    staticClass: "flex-1 text-center"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.format.radius', {
    unit: _vm.unit,
    radius: _vm.to
  })))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b8bf234"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radius-slider/RadiusSlider.vue
// module id = 934
// module chunks = 1